import { useFlags } from 'launchdarkly-react-client-sdk';
import { useCheckFeatureGating } from '@nile/components/src/HOC/withPlanFeatureGating';
import {
  getTranslatedText,
  useProduct,
  COMMON_CONSTANTS
} from '@nile/components';
import { useIntl } from 'react-intl';

export const getLeftNavCreateList = () => {
  const flags = useFlags();
  const intl = useIntl();
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);
  const contractsNew = useCheckFeatureGating('CONTRACT_V3');
  const showNetworkView = useCheckFeatureGating('network-monitoring-system');

  const finalCreateList = {
    createMyWorkList: {
      categoryHeading: 'app.create.newWork',
      data: [
        {
          name: 'TICKET',
          label: 'app.modules.workspace.ticket',
          icon: 'TicketModule',
          authorisation: 'tickets',
          featureGateName: 'TICKETING'
        },
        {
          name: 'PROJECTS',
          label: 'app.modules.workspace.project',
          icon: 'ProjectModule',
          authorisation: 'project',
          featureGateName: 'PROJECT_MANAGEMENT'
        }
      ]
    },
    assetList: {
      categoryHeading: 'app.modules.asset',
      data: [
        {
          name: 'SCRIPTS',
          label: 'app.modules.asset.script',
          icon: 'ScriptModule',
          authorisation: 'script',
          featureGateName: 'SCRIPTING'
        }
      ]
    },
    clientList: {
      categoryHeading: 'app.modules.client',
      productToCheck: 'MSP',
      data: [
        {
          name: 'CLIENTS',
          label: 'client.mainpage.header',
          icon: 'ClientModule',
          authorisation: 'client',
          featureGateName: 'CLIENT_MANAGEMENT'
        },
        {
          name: 'NEW_CONTRACT_TEMPLATE',
          label: 'app.modules.workspace.contractTemplate',
          icon: 'ContractModule',
          authorisation: 'contractTemplate',
          featureGateName: 'CONTRACT_MANAGEMENT',
          newFeatureCheck: 'CONTRACT_V3'
        },
        {
          name: 'NEW_INVOICE',
          label: 'app.create.invoice.title',
          icon: 'InvoiceModule',
          authorisation: 'invoice',
          featureGateName: 'INVOICING'
        },
        {
          name: 'NEW_QUOTE',
          label: 'app.create.quote.title',
          icon: 'QuoteModule',
          authorisation: 'quote', // TODO-QUOTE: Change to quote
          featureGateName: 'QUOTING'
        },
        {
          name: 'MAIL_BOX',
          label: 'app.create.newEmail.title',
          icon: 'SalesInboxModule',
          authorisation: 'clientConversation',
          operation: 'add',
          featureGateName: 'SALES_INBOX'
        }
      ]?.filter((item) => {
        if (contractsNew?.enabled) {
          return item.name !== 'NEW_CONTRACT_TEMPLATE';
        }
        return item;
      })
    },
    reportsList: {
      categoryHeading: 'reports.create.report.btn',
      data: [
        {
          name: 'REPORTS',
          label: 'reports.stepnavi.dashboard.title',
          icon: 'ReportsModule',
          authorisation: 'report',
          featureGateName: 'CUSTOM_REPORTS'
        },
        {
          name: 'CHARTS',
          label: 'app.modules.widgets.title',
          icon: 'ChartModule',
          authorisation: 'report',
          featureGateName: 'CUSTOM_REPORTS'
        }
      ]
    },
    createOthersModule: {
      categoryHeading: 'common.documentation',
      data: [
        {
          name: 'ITDOC',
          label: 'app.modules.it.template',
          icon: 'ItDocumentModule',
          authorisation: 'itDocumentationCategory',
          featureGateName: 'IT_DOCUMENTATION'
        },
        {
          name: 'KNOWLEDGE_BASE',
          label: 'app.kb.new.article.label',
          icon: 'KnowledgeBaseModule',
          authorisation: 'knowledgeBase',
          featureGateName: 'KNOWLEDGE_BASE',
          featureTag: {
            label: getTranslatedText(intl, 'changeLog.nav.new.header'),
            visible: true
          }
        }
      ]
    }
  };

  if (
    showNetworkView?.enabled ||
    showNetworkView?.upsell ||
    flags.networkEndpointAsset
  ) {
    finalCreateList['assetList'].data.push({
      name: 'PROBE',
      label: 'snmp.probe',
      icon: 'NetworkMonitoring',
      authorisation: 'assetViews',
      featureGateName: flags.networkEndpointAsset
        ? null
        : 'network-monitoring-system'
    });

    finalCreateList['assetList'].data.push({
      name: 'CREDENTIALS',
      label: 'common.credential',
      icon: 'CredentialNavIcon',
      authorisation: 'assetViews',
      featureGateName: flags.networkEndpointAsset
        ? null
        : 'network-monitoring-system'
    });
  }

  return finalCreateList;
};

export const getLeftNavModuleList = () => {
  const flags = useFlags();
  const intl = useIntl();
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);
  const showNetworkView = useCheckFeatureGating('network-monitoring-system');
  const schedulingFeaturegating = useCheckFeatureGating('calendar_scheduling');
  const contractsNew = useCheckFeatureGating('CONTRACT_V3');
  const isSchedulingEnabled =
    schedulingFeaturegating?.enabled || schedulingFeaturegating?.upsell;

  const finalModuleList = {
    myWorkList: {
      categoryHeading: isSchedulingEnabled
        ? 'app.modules.workManagement'
        : 'app.modules.workspace',
      data: [
        {
          name: 'WORKSPACE',
          label: 'app.modules.workspace.ticket',
          icon: 'TicketModule',
          authorisation: 'tickets',
          featureGateName: 'TICKETING'
        },
        {
          name: 'TASKS',
          label: 'app.modules.workspace.task',
          icon: 'TaskModule',
          authorisation: 'taskViews',
          featureGateName: 'TASK'
        },
        {
          name: 'PROJECTS',
          label: 'app.modules.workspace.project',
          icon: 'ProjectModule',
          ldFlag: 'projectManagement',
          authorisation: 'project',
          featureGateName: 'PROJECT_MANAGEMENT'
        },
        {
          name: 'TIMESHEET',
          // label: 'Timesheet',
          label: 'app.modules.workspace.timesheet',
          icon: 'TimesheetModule',
          // authorisation: 'project',
          featureGateName: 'ST_TECH_MY_TIMERS'
        }
      ]
    },
    assetManagement: {
      categoryHeading: 'app.modules.asset',
      data: [
        {
          name: 'ASSETS',
          label: 'ticket.details.insights.assets',
          icon: 'AssetModule',
          authorisation: 'assetViews',
          featureGateName: 'WINDOWS_MANAGEMENT'
        },
        {
          name: 'ALERTS',
          label: 'app.modules.asset.alert',
          icon: 'AlertModule',
          authorisation: 'alertView',
          featureGateName: 'ALERT'
        },
        {
          name: 'PATCHES',
          label: 'app.modules.asset.patch',
          icon: 'PatchModule',
          authorisation: 'patchViews',
          featureGateName: 'OS_PATCH_MANAGEMENT'
        },
        {
          name: 'COMMUNITY_SCRIPTS',
          label: 'app.modules.asset.script',
          icon: 'ScriptModule',
          authorisation: 'script',
          featureGateName: 'SCRIPTING'
        }
      ]
    },
    clientManagement: {
      categoryHeading: 'app.modules.client',
      productToCheck: 'MSP',
      data: [
        {
          name: 'CLIENTS',
          label: 'client.mainpage.header',
          icon: 'ClientModule',
          authorisation: 'client',
          featureGateName: 'CLIENT_MANAGEMENT'
        },
        contractsNew?.enabled
          ? {
              name: 'ALL CONTRACTS',
              label: 'contractViews.allContracts.new.label',
              icon: 'ContractModule',
              authorisation: 'contract',
              featureGateName: 'CONTRACT_V3'
            }
          : {
              name: 'CONTRACT TEMPLATE',
              label: 'app.modules.workspace.contractTemplate',
              icon: 'ContractModule',
              authorisation: 'contractTemplate',
              featureGateName: 'CONTRACT_MANAGEMENT'
            },
        {
          name: 'INVOICE AUDIT',
          label: 'invoiceViews.invoiceAudit.label',
          icon: 'InvoiceAuditModule',
          authorisation: 'invoice',
          featureGateName: 'INVOICING'
        },
        {
          name: 'INVOICE',
          label: 'invoiceViews.navigation.header',
          icon: 'InvoiceModule',
          authorisation: 'invoice',
          featureGateName: 'INVOICING'
        },
        {
          name: 'QUOTES',
          label: 'quoteViews.navigation.header',
          icon: 'QuoteModule',
          authorisation: 'quote', // TODO-QUOTE: Change to quote
          featureGateName: 'QUOTING'
        },
        {
          name: 'SALES_INBOX',
          label: 'client.views.salesInbox',
          icon: 'SalesInboxModule',
          authorisation: 'clientConversation',
          operation: 'view',
          featureGateName: 'SALES_INBOX'
        }
      ]
    },
    orgManagement: {
      categoryHeading: 'itsm.label.org.management',
      productToCheck: 'IT',
      data: [
        {
          name: 'ORGANIZATION',
          label: 'common.my.company',
          icon: 'OrganizationColoured',
          authorisation: 'insights'
        },
        {
          name: 'SITE',
          label: 'common.sites',
          icon: 'SiteNew',
          authorisation: 'insights'
        },
        {
          name: 'DEPARTMENT',
          label: 'common.department',
          icon: 'DepartmentColoured',
          authorisation: 'insights'
        },
        {
          name: 'USERS',
          label: 'common.users',
          icon: 'UserColoured',
          authorisation: 'insights'
        }
      ]
    },
    documentation: {
      categoryHeading: 'common.documentation',
      data: [
        {
          name: 'ITDOC',
          label: 'asset.sidebar.ITdoc',
          icon: 'ItDocumentModule',
          authorisation: 'itDocumentation',
          featureGateName: 'IT_DOCUMENTATION'
        },
        {
          name: 'KNOWLEDGE_BASE',
          label: 'common.knowledge.base',
          icon: 'KnowledgeBaseModule',
          authorisation: 'knowledgeBase',
          featureGateName: 'KNOWLEDGE_BASE',
          featureTag: {
            label: getTranslatedText(intl, 'changeLog.nav.new.header'),
            visible: true
          }
        }
      ]
    },
    OtherModules: {
      categoryHeading: 'app.common.more',
      data: [
        {
          name: 'REPORTS',
          label: 'reports.stepnavi.reports.title',
          icon: 'ReportsModule',
          // ldFlag: 'reports',
          authorisation: 'report',
          featureGateName: 'REPORTS'
        }
        // {
        //   name: 'CHARTS',
        //   label: 'app.modules.widgets.title',
        //   icon: 'chartModule',
        //   ldFlag: 'charts',
        //   authorisation: 'report'
        // }
      ]
    }
  };
  if (isSchedulingEnabled) {
    finalModuleList['myWorkList'].data.push({
      name: 'SCHEDULING',
      label: 'app.modules.workspace.scheduling',
      icon: 'SchedulingModule',
      featureGateName: 'calendar_scheduling'
    });
  }

  if (
    showNetworkView?.enabled ||
    showNetworkView?.upsell ||
    flags.networkEndpointAsset
  ) {
    finalModuleList['assetManagement'].data.push({
      name: 'NETWORK_MONITOR',
      label: 'snmp.network.monitoring',
      icon: 'NetworkMonitoring',
      // isNewFeature: true,
      authorisation: 'assetViews',
      featureGateName: flags.networkEndpointAsset
        ? null
        : 'network-monitoring-system'
    });
  }

  return finalModuleList;
};
